/* eslint-disable react/prop-types */
import { Box, makeStyles } from "@material-ui/core";
import _ from "lodash";
import React from "react";
import CompetitorSliderComponent from "./CompetitorSliderComponent";

const useStyles = makeStyles(() => ({
  competitorItem: {
    justifySelf: "center",
    height: "100%",
    width: "100%",
  },
}));

const CompetitorSliderRow = ({
  label,
  competitorsFilters,
  setSlidersData,
  sliderValue,
  price,
  companyId,
  brandId,
  categoryId,
  brandIdx,
  companyIdx,
  categoryIdx,
}) => {
  const classes = useStyles();
  const SLIDER_MIN_VALUE = -30;
  const SLIDER_MAX_VALUE = 30;

  const handleDeleteCompetitor = (competitor) => {
    setSlidersData((prevState) => {
      const newState = _.cloneDeep(prevState);
      if (competitorsFilters.groupBy.key === "category-company") {
        const { companies } = newState[competitor.categoryIdx];
        companies[competitor.companyIdx].isShowed = false;
        companies[competitor.companyIdx].sliderValue = 0;
        return newState;
      }
      const { companies } = newState[competitor.categoryIdx];
      const { brands } = companies[competitor.companyIdx];
      brands[competitor.brandIdx].isShowed = false;
      brands[competitor.brandIdx].sliderValue = 0;
      return newState;
    });
  };

  const handleChangeCompetitorValue = (competitor, newValue) => {
    setSlidersData((prevState) => {
      const newState = _.cloneDeep(prevState);
      if (
        _.some(
          _.pick(competitorsFilters, ["brand", "category", "company"]),
          (value) => value !== ""
        )
      ) {
        // The competitor IDX are wrong when comparing it with the oldstate because the old state is not filtered so we need to find the proper index to get the correct values when there is some filters.
        const realCategoryIdx = _.findIndex(newState, {
          id: competitor.categoryId,
        });
        const realCompanyIdx = _.findIndex(
          newState[realCategoryIdx].companies,
          { id: competitor.companyId }
        );
        const realBrandIdx = _.findIndex(
          newState[realCategoryIdx].companies[realCompanyIdx].brands,
          { id: competitor.brandId }
        );
        if (competitorsFilters.groupBy.key === "category-company") {
          const { companies } = newState[realCategoryIdx];
          companies[realCompanyIdx].sliderValue = newValue;
          return newState;
        }
        const { companies } = newState[realCategoryIdx];
        const { brands } = companies[realCompanyIdx];
        brands[realBrandIdx].sliderValue = newValue;
        companies[realCompanyIdx].sliderValue = newValue;
      } else {
        if (competitorsFilters.groupBy.key === "category-company") {
          const { companies } = newState[competitor.categoryIdx];
          companies[competitor.companyIdx].sliderValue = newValue;
          return newState;
        }
        const { companies } = newState[competitor.categoryIdx];
        const { brands } = companies[competitor.companyIdx];
        brands[competitor.brandIdx].sliderValue = newValue;
        companies[competitor.companyIdx].sliderValue = newValue;
      }
      return newState;
    });
  };

  const calculatedPrice = _.round(
    (sliderValue === "-" ? 0 : sliderValue / 100) * price + price,
    1
  );

  const selectedOption = {
    label,
    companyId,
    brandId,
    categoryId,
    brandIdx,
    companyIdx,
    categoryIdx,
  };

  const shouldShowActions =
    competitorsFilters.company === "" || competitorsFilters.brands === "";
  return (
    <>
      <Box className={classes.competitorItem}>
        <CompetitorSliderComponent
          sliderValue={sliderValue}
          productPrice={calculatedPrice}
          selectedOption={selectedOption}
          onValueChange={handleChangeCompetitorValue}
          minValue={SLIDER_MIN_VALUE}
          maxValue={SLIDER_MAX_VALUE}
          unit="%"
          description="The variation offered range allowed for every competitor product."
          onDeleteCompetitor={
            shouldShowActions ? handleDeleteCompetitor : () => {}
          }
        />
      </Box>
    </>
  );
};

export default CompetitorSliderRow;
